import { Row, Col, Badge } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { RootState } from "redux/store";
import { useEffect, useState } from "react";
import { Table } from "components";
import { getStores } from "redux/slices/Stores";
import { StoresPopup } from "popups/Stores/Stores";
import { updateCatalogueField, getCatalogueStores, addSelectedStores, updateCatalogueModelField } from "redux/slices/Catalogues";
import { getRowIds } from "helpers/data/dataHandling";

export default function OldStores() {
    const dispatch = useAppDispatch();
    const stores = useAppSelector((state: RootState) => state.stores);
    const catalogue = useAppSelector((state: RootState) => state.catalogues);
    const currentStoreGroupId = useAppSelector((state: RootState) => state.global.storeGroupId);
    const [allowedStoreIds, setAllowedStoreIds] = useState<number[]>([]);
    const [visibleStores, setVisisbleStores] = useState<any[]>([]);
    const columnsA = [
        {
            Header: "Name",
            accessor: "name",
            defaultCanSort: true,
            width: 200,
        },
        {
            Header: "Store Status",
            accessor: "storeId",
            width: 200,
            Cell: (row: any) => {
                let match = stores.table.find((i: any) => i.id == row.cell.row.original.id);
                //@ts-ignore
                return match?.connected === true ? (<Badge className="me-1 badge-outline-success">Online</Badge>) : (<Badge className="me-1 badge-outline-danger">Offline</Badge>)
            },
        },
        {
            Header: "Status",
            accessor: "status",
            width: 200,
            Cell: (row: any) => <>
                {catalogue.sentStoreList.includes(row.cell.row.original.id as never) ? (<Badge className="me-1 badge-outline-success">Sent</Badge>) : (<Badge className="me-1 badge-outline-warning">Pending</Badge>)}
            </>,
        },
        {
            Header: "No. of lines",
            accessor: "lines",
            defaultCanSort: true,
            width: 200,
            Cell: (row: any) => <>
                {handleStoreNumber(row.cell.row.original)}{row.value}
            </>,
        }
    ];

    useEffect(() => {
        if (catalogue.model.catalogueId && catalogue.model.stores.length > 0) {
            getAllowedStores();
            dispatch(getCatalogueStores({ ids: [catalogue.model.catalogueId], stores: catalogue.model.stores }));
        }
    }, [currentStoreGroupId, catalogue.model.catalogueId]);

    useEffect(() => {
        setAllowedStoreIds(catalogue.allowedStores.map((i: any) => i.id));
    }, [catalogue.allowedStores]);

    useEffect(() => {
        const table: any[] = [];
        catalogue.allowedStores.forEach((store: any) => {
            if(catalogue.model.stores.includes(store.id as never)) table.push(store);
        });
        setVisisbleStores(table);
    }, [catalogue.stores, allowedStoreIds]);

    async function getAllowedStores(){
        await dispatch(getStores({ storeGroupId: currentStoreGroupId })).then((res) => {
            if( res.data.length > 0)  dispatch(updateCatalogueField({ key: "allowedStores", value: res.data }));
        });
    }

    function handleStoreNumber(store: any) {
        //@ts-ignore
        let match = catalogue.stores.find(i => i.id == store.id);
        if (match) {
            //@ts-ignore
            return match.lines;
        }
        return "";
    }

    return (
        <Row>
            <Col xs={12} style={{height: "60dvh"}}>
                <Table
                    title="Stores"
                    disableExport
                    pageSize={15}
                    isSortable={true}
                    autoHeight
                    pagination={true}
                    loading={catalogue.loadingStores}
                    columns={columnsA}
                    data={visibleStores}
                />
            </Col>
        </Row>
    );
}